import { render, staticRenderFns } from "./PalletiseByCubicPackingForm.vue?vue&type=template&id=4f0e8a63"
import script from "./PalletiseByCubicPackingForm.vue?vue&type=script&lang=js"
export * from "./PalletiseByCubicPackingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports